
import FormFieldset from '@/components/block/FormFieldset.vue'
import InputInlineText from '@/components/elements/InputInlineText.vue'
import { SetupContext, reactive } from 'vue'

export default {
  name: 'FormInputField',

  components: {
    FormFieldset,
    InputInlineText
  },

  props: {
    id: String,
    label: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    formGroupReq: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: String,
    description: String,
    placeholder: String,
    size: String,
    passwordSwitch: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: String,
    name: String,
    type: String
  },

  setup(props: any, context: SetupContext) {
    const input = reactive({
      type: props.type
    })

    const callInputChange = (value: string) => {
      context.emit('change-message', value)
    }

    const toggeleShowPwassword = () => {
      input.type = input.type === 'text' ? 'password' : 'text'
    }

    return {
      input,
      callInputChange,
      toggeleShowPwassword
    }
  }
}
